import { Component, inject, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { firstValueFrom, Observable, Subject, Subscription } from 'rxjs';
import { AlertaService } from '../../alerta/alerta.service';
import { LoadingService } from '../../loading/loading.service';
import { UsuarioService } from '../../usuario/usuario.service';
import { iEntrada, iCatalogos } from '../entrada.interface';
import { EntradaService } from '../entrada.service';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { provideNativeDateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../app.state';
import { selectUsuario } from '../../states/usuario/selector';
import { selectEntrada } from '../../states/entrada/selector';
import { selectComentarios } from '../../states/comentarios/selector';
import { ActivatedRoute } from '@angular/router';
import { iUsuario } from '../../usuario/usuario.interface';
import { cargaComentarios } from '../../states/comentarios/actions';
import { CommonModule } from '@angular/common';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import moment from 'moment';

@Component({
  selector: 'app-add-edit-comentarios',
  standalone: true,
  imports: [CommonModule,
    ReactiveFormsModule, 
    MatToolbarModule, 
    MatButtonModule, 
    MatIconModule, 
    MatInputModule, 
    MatFormFieldModule, 
    FormsModule, 
    MatDatepickerModule],
  providers: [
    //provideNativeDateAdapter(),
    provideMomentDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'es-MX' }
  ],
  templateUrl: './add-edit-comentarios.component.html',
  styleUrl: './add-edit-comentarios.component.css'
})
export class AddEditComentariosComponent {
  private active = inject(ActivatedRoute);
  private loadingService = inject(LoadingService);
  private entradaService = inject(EntradaService);
  private usuarioService = inject(UsuarioService);
  private alertaService = inject(AlertaService);
  private formBuilder:FormBuilder = inject(FormBuilder);
  private readonly store: Store<AppState> = inject(Store);
  private readonly stateUsuario: any = this.store.pipe(select(selectUsuario));
  private readonly stateEntrada: any = this.store.pipe(select(selectEntrada));
  private readonly stateComentarios: any = this.store.pipe(select(selectComentarios));
  private idEntrada = this.active.snapshot.params['id'];
  private idTema = this.active.snapshot.params['tema'];
  private subscriptions = new Subscription();

  @Input() listenToFather!: Observable<boolean>;
  @Output() sendToFather: Subject<any> = new Subject();
  
  public oEntrada: iEntrada;
  public oUsuario: iUsuario;
  public oEntradaHistorico: any;
  public formComentarios!: FormGroup;
  public listaComentarios: any[] = [];
  public editComentarios: any = null;
  public moment: any = moment;
  public deshabilitado: boolean = false;
  public campos: any[] = [];
  
  constructor() {
    this.loadingService.show();

    this.oUsuario = this.stateUsuario.state().usuario;
    this.oEntrada = structuredClone(this.stateEntrada.state().entrada);
    this.oEntradaHistorico = this.active.snapshot.queryParamMap.get('historicoEntrada');

    this.formComentarios = this.formBuilder.group({
      bb: [false],
      bb_enviado: [''],
      bb_enviado_descripcion: [''],
      fecha: ['', [Validators.required]],
      descripcion: ['', [Validators.required, Validators.maxLength(10000)]],
      usuario: [''],
      tsCreation: [moment().format('YYYY-MM-DD HH:mm:ss')]
    });

    this.loadingService.hide();
  }

  async ngOnInit() {
    this.loadingService.show();
    const busqueda = this.active.snapshot.queryParamMap.get('campo');
    this.campos = (busqueda?.split('|'))? busqueda?.split('|') : [];

    if(this.idEntrada != "add") {
      this.listaComentarios = await firstValueFrom(this.entradaService.getComentario(this.idEntrada));
      this.listaComentarios.sort((a,b) => Date.parse(a.fecha) - Date.parse(b.fecha));
    } else if(this.oEntradaHistorico) {
      await this.cargarComentariosHistorico();
    }
    
    const oComentarios = structuredClone(this.listaComentarios);
    this.store.dispatch(cargaComentarios({ oComentarios }));

    ///////////////////////////// ONCHANGE BUSINESS RULES //////////////////////////////
    this.autorizacionComentarios();
    ////////////////////////////////////////////////////////////////////////////////////

    this.subscriptions.add(
      this.listenToFather.subscribe((oData: any) => {
        if(oData.accion == 'disabled') {
          this.deshabilitado = oData.deshabilitado;
          if(oData.deshabilitado) {
            this.formComentarios.disable({emitEvent: false});
          } else {
            this.formComentarios.enable({emitEvent: false});
          }
        }
      })
    );

    if(this.idEntrada != 'add') {
      this.deshabilitado = true;
      this.formComentarios.disable({emitEvent: false});
    }

    this.loadingService.hide();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  resetForm() {
    this.editComentarios = null;
    this.formComentarios.reset();
  }

  edit(index: number, item: any) {
    this.editComentarios = {index: index, ...item};

    this.formComentarios.patchValue({
      fecha: moment(item.fecha, "YYYY-MM-DD").toDate(),
      descripcion: item.descripcion,
      usuario: this.oUsuario.nombre,
      tsCreation: item.tsCreation
    });
  }

  delete(index: number, item: any) {
    console.log(item);
    const dialogRef = this.alertaService.eliminarComentario({
      title: `¿Está seguro de eliminar el comentario?`,
      description: 'Confirme que desea eliminar el comentario, recuerde que esta acción es permanente.',
      index: index, 
      item: item
    });

    dialogRef.afterClosed().subscribe((result:any) => {
      if(!result) return;
      this.listaComentarios.splice(result.index, 1);
      const oComentarios = structuredClone(this.listaComentarios);
      this.store.dispatch(cargaComentarios({ oComentarios }));
      
      if(item.entrada && item.id) {
        this.entradaService.delComentario(item.entrada, item.id);
      }
      this.resetForm();
    });
  }

  save() {
    if(!this.formComentarios.invalid) {
      let comentarios: any = this.formComentarios.value;
      comentarios.fecha = moment(comentarios.fecha).format("YYYY-MM-DD");
      comentarios.usuario = this.oUsuario.nombre;
      
      if(this.editComentarios) {
        const updateComentarios = {...this.editComentarios, ...comentarios};
        this.listaComentarios[this.editComentarios.index] = updateComentarios;
      } else {
        this.listaComentarios.push(comentarios);
      }

      this.listaComentarios.sort((a,b) => Date.parse(a.fecha) - Date.parse(b.fecha));

      const oComentarios = structuredClone(this.listaComentarios);
      this.store.dispatch(cargaComentarios({ oComentarios }));
      this.resetForm();
    }
  }

  autorizacionComentarios() {
    this.listaComentarios = this.listaComentarios.map((item:any) => {
      item.entrada = this.idEntrada;
      item.desactivado = false;
      if(item.usuario != this.oUsuario.nombre && this.oUsuario.rol < 4) {
        item.desactivado = true;
      }
      return item;
    });
  }

  async cargarComentariosHistorico () {
    const params = this.oEntradaHistorico.split('/');
    if(params.length == 2) {
      const entrada = await firstValueFrom(this.entradaService.obtenerHistorico(params[1], params[0]));
      if(entrada != null && entrada.comentarios) {
        this.formComentarios.get('descripcion')?.setValue(entrada.comentarios);
      }
    }
  }
}
